module.exports = __webpack_public_path__ + "static/media/Muli-ExtraBold.ae2a95d9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli/Muli-ExtraBold.ttf
// module id = 1297
// module chunks = 1